import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/wb-logo.jpeg";

function Sidenav() {
  const { pathname } = useLocation();

  // Icons for different menu items
  const ProfileIcon = () => (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
        clipRule="evenodd"
      />
    </svg>
  );

  const ChatIcon = () => (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
      <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
      <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
    </svg>
  );

  const RupeeIcon = () => (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M13.66 7H16v2h-2.34c-.59 1.56-2.42 2.85-5.66 2.85V14c2.44 0 4.44-1.73 4.44-4.15 0-.75-.25-1.43-.78-1.85zM8 7h5.66C14.06 5.74 15.38 5 17 5V3H7v2h1zm0 4h2.34C10.94 9.26 9.62 8 8 8V7H6v2c0 1.1.9 2 2 2zm0 6v2h2v-2H8zm6 0h2v2h-2v-2z" />
      <path d="M7 13h2v2H7v-2zm0-4h2v2H7V9z" />
    </svg>
  );

  const HistoryIcon = () => (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
        clipRule="evenodd"
      />
    </svg>
  );

  const menuItems = [
    {
      key: "profile",
      path: "/profile",
      label: "Profile",
      icon: <ProfileIcon />,
    },
    {
      key: "chats",
      path: "/chats",
      label: "Chat",
      icon: <ChatIcon />,
    },
    {
      key: "Earnings Dashboard",
      path: "/earnings-dashboard",
      label: "Call History",
      icon: <RupeeIcon />,
    },
    {
      key: "redeem-history",
      path: "/redeem-history",
      label: "Redeem",
      icon: <HistoryIcon />,
    },
  ];

  return (
    <div className="h-[90dvh] bg-gradient-to-b  rounded-xl from-white to-gray-50/50 shadow-lg border-r border-gray-200/60 flex flex-col relative overflow-hidden">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,#A40165_1px,transparent_1px)] bg-[length:20px_20px]"></div>
      </div>

      {/* Logo Section */}
      <div className="relative p-4 sm:p-6 border-b border-gray-100/80 bg-white/50 backdrop-blur-sm">
        <div className="flex justify-center">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#A40165]/20 to-pink-500/20 rounded-xl blur opacity-0 group-hover:opacity-100 transition duration-500"></div>
            <img
              className="relative w-20 h-20 sm:w-28 sm:h-28 object-cover rounded-xl shadow-md hover:shadow-xl transition-all duration-500 ring-2 ring-white/50"
              src={logo}
              alt="Logo"
            />
          </div>
        </div>
        <div className="mt-3 text-center">
          <div className="text-[10px] sm:text-xs font-medium text-gray-500 tracking-wider uppercase">
            Dashboard
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 px-3 py-4 sm:px-4 sm:py-6 space-y-1 sm:space-y-2 relative overflow-y-scroll">
        {menuItems.map((item, index) => {
          const isActive = pathname === item.path;
          return (
            <div key={item.key} className="relative">
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `group flex items-center px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm font-medium rounded-xl transition-all duration-300 relative overflow-hidden ${isActive
                    ? "bg-gradient-to-r from-[#A40165]/8 to-[#A40165]/4 text-[#A40165] shadow-sm border border-[#A40165]/10"
                    : "text-gray-600 hover:bg-white/80 hover:text-gray-800 hover:shadow-sm"
                  }`
                }
                style={{
                  animationDelay: `${index * 100}ms`,
                }}
              >
                {/* Active background glow */}
                {isActive && (
                  <div className="absolute inset-0 bg-gradient-to-r from-[#A40165]/5 to-transparent rounded-xl"></div>
                )}

                <span
                  className={`relative flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-lg mr-2 sm:mr-3 transition-all duration-300 ${isActive
                    ? "bg-[#A40165]/15 text-[#A40165] shadow-sm"
                    : "bg-gray-100/80 text-gray-500 group-hover:bg-white group-hover:text-gray-700 group-hover:shadow-sm"
                    }`}
                >
                  <div
                    className={`transition-transform duration-300 ${isActive ? "scale-110" : "group-hover:scale-105"
                      }`}
                  >
                    {item.icon}
                  </div>
                </span>

                <span className="relative truncate font-medium">
                  {item.label}
                </span>

                {/* Active indicator with animation */}
                {isActive && (
                  <div className="ml-auto flex items-center space-x-1">
                    <div className="w-2 h-2 bg-[#A40165] rounded-full animate-pulse"></div>
                    <div
                      className="w-1 h-1 bg-[#A40165]/60 rounded-full animate-pulse"
                      style={{ animationDelay: "0.5s" }}
                    ></div>
                  </div>
                )}

                {/* Hover effect line */}
                <div
                  className={`absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-[#A40165] to-pink-500 rounded-r-full transition-all duration-300 ${isActive
                    ? "opacity-100 scale-y-100"
                    : "opacity-0 scale-y-0 group-hover:opacity-50 group-hover:scale-y-100"
                    }`}
                ></div>
              </NavLink>
            </div>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="relative p-3 sm:p-4 border-t border-gray-100/80 bg-white/30 backdrop-blur-sm">
        <div className="text-[10px] sm:text-xs text-gray-500 text-center">
          <div className="flex items-center justify-center mb-2">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#A40165]/30 to-transparent"></div>
            <div className="px-3">
              <div className="w-2 h-2 bg-[#A40165]/40 rounded-full animate-pulse"></div>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#A40165]/30 to-transparent"></div>
          </div>
          <div className="font-medium tracking-wide">Consultant Portal</div>
        </div>
      </div>
    </div>
  );
}

export default Sidenav;
